import {
  func, shape, string,
} from 'prop-types';
import React from 'react';
import FormInputContainer from '../../../scaffolding/FormInputContainer/FormInputContainer';
import SchoolSearchV2 from '../../../controls/SchoolSearchV2/SchoolSearchV2';

const SchoolSearchWithLabelV2 = ({
  id,
  label,
  brand,
  value, // Institution name
  searchServiceUrl,
  iamApiUrl,
  errorMsg,
  onChange,
  onSelect,
}) => (
  <FormInputContainer id={`${id}_container`}>
    <label id={`${id}_label`} htmlFor={id}>{label}</label>

    <SchoolSearchV2
      id={id}
      value={value}
      width="100%"
      searchUrl={searchServiceUrl}
      iamApiUrl={iamApiUrl}
      brand={brand}
      hasError={errorMsg?.length > 0}
      aria-invalid={errorMsg?.length > 0}
      aria-describedby={`${id}_error`}
      onChange={onChange}
      onSelect={onSelect}
    />

    <div role="alert" aria-live="assertive" id={`${id}_error`}>
      {
        errorMsg?.length > 0
        && <div className="errorText">{errorMsg}</div>
      }

      {
        value?.length > 150
        && <div className="errorText" id={`${id}_length`}>Limit of 150 characters reached</div>
      }
    </div>
  </FormInputContainer>
);

SchoolSearchWithLabelV2.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  brand: shape({
    short: string.isRequired,
    full: string.isRequired,
  }).isRequired,
  value: string, // Institution name
  searchServiceUrl: string.isRequired,
  iamApiUrl: string.isRequired,
  errorMsg: string,
  onChange: func.isRequired,
  onSelect: func.isRequired,
};

SchoolSearchWithLabelV2.defaultProps = {
  value: '',
  errorMsg: null,
};

export default SchoolSearchWithLabelV2;
